import {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_MeldiDham/partials'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
export function PrivateRoutes() {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  // ============================ Master ========================
  const CountryMasterPage = lazy(
    () => import('../modules/master-page/country-master-page/CountryMasterPage')
  )
  // ================================================================
  const StateMasterPage = lazy(
    () => import('../modules/master-page/state-master-page/StateMasterPage')
  )
  // ================================================================
  const CityMasterPageMasterPage = lazy(
    () => import('../modules/master-page/district-master-page/CityMasterPageMasterPage')
  )
  // ================================================================
  const TalukaMasterPage = lazy(
    () => import('../modules/master-page/taluka-master-page/TalukaMasterPage')
  )
  // ================================================================
  const NationalityMasterPage = lazy(
    () => import('../modules/master-page/nationality-master-page/NationalityMasterPage')
  )
  // ================================================================
  const EducationCategoryPage = lazy(
    () => import('../modules/master-page/education-category-master-page/EducationCategoryPage')
  )
  // ================================================================
  const EducationDepartmentPage = lazy(
    () => import('../modules/master-page/education-department-master-page/EducationDepartmentPage')
  )
  // ================================================================
  const DocumentTypePage = lazy(
    () => import('../modules/master-page/document-type-page/DocumentTypePage')
  )
  // ================================================================
  const KycDocumentMasterPage = lazy(
    () => import('../modules/master-page/kyc-document-page/KycDocumentMasterPage')
  )
  // ================================= Organization ==========================
  const EmployeeMasterPage = lazy(
    () => import('../modules/organization-page/employee-master-page/EmployeeMasterPage')
  )
  // ================================================================
  const UserMasterPage = lazy(
    () => import('../modules/organization-page/user-master-page/UserMasterPage')
  )
  // ================================================================
  const CustomerMasterPage = lazy(
    () => import('../modules/organization-page/customer-master-page/CustomerMasterPage')
  )
  // ================================================================
  const DepartmentMasterPage = lazy(
    () => import('../modules/master-page/department-master-page/DepartmentMasterPage')
  )
  // ================================================================
  const DesignationMasterPage = lazy(
    () => import('../modules/master-page/designation-master-page/DesignationMasterPage')
  )
  // ================================================================
  const BranchMasterPage = lazy(
    () => import('../modules/master-page/branch-master-page/BranchMasterPage')
  )
  // ================================================================
  const OrganizationBankMasterPage = lazy(
    () => import('../modules/master-page/organization-bank-master-page/OrganizationBankMasterPage')
  )
  // ================================================================
  // const ChangePasswordPage = lazy(() => import('../modules/change-password/ChangePasswordPage'))

  // ================================================================
  const AreaPinCodeMasterPage = lazy(
    () => import('../modules/master-page/area-pincode-master-page/AreaPinCodeMasterPage')
  )

  // ============================================================================
  const BannerImageMasterPage = lazy(
    () => import('../modules/master-page/banner-image-master-page/BannerImageMasterPage')
  )

  const ConfigurationMasterPage = lazy(
    () => import('../modules/configuration-master-page/ConfigurationMasterPage')
  )

  // ============================================================================
  const BlogMasterPage = lazy(() => import('../modules/master-page/Blog/BlogMasterPage'))
  const EventMasterPage = lazy(() => import('../modules/master-page/Event/EventMasterPage'))
  const AlbumMediaMasterPage = lazy(
    () => import('../modules/master-page/AlbumMedia/AlbumMediaMasterPage')
  )
  const AlbumMasterPage = lazy(() => import('../modules/master-page/Album/AlbumMasterPage'))
  const ServiceMasterPage = lazy(
    () => import('../modules/master-page/service-master/ServiceMasterPage')
  )

  const MemberTypeMasterPage = lazy(
    () => import('../modules/master-page/member-type-master/MemberTypeMasterPage')
  )

  const ItemMasterPage = lazy(
    () => import('../modules/product-master/item-master-page/ItemMasterPage')
  )
  const ItemCategoryMaterPage = lazy(
    () => import('../modules/product-master/item-category-master-page/ItemCategoryMaterPage')
  )

  const ActiveMemberMasterPage = lazy(
    () => import('../modules/ram-nam-book-bank/active-member/ActiveMemberMasterPage')
  )
  const NotVerifiedMemberMasterPage = lazy(
    () => import('../modules/ram-nam-book-bank/not-verified-members/NotVerifiedMemberMasterPage')
  )

  const InwardOutwardMasterPage = lazy(
    () => import('../modules/ram-nam-book-bank/inward-outward-book/InwardOutwardMasterPage')
  )

  const OrderMasterMasterPage = lazy(() => import('../modules/orders/OrderMasterMasterPage'))
  const AddressReportMasterPage = lazy(
    () => import('../modules/address-report/AddressReportMasterPage')
  )

  const MemberReportMasterPage = lazy(
    () => import('../modules/member-report/MemberReportMasterPage')
  )
  const RequestForgotPasswordMasterPage = lazy(
    () => import('../modules/req-forgot-pwd/ForgotPasswordMasterPage')
  )

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path='/dashboard' component={DashboardWrapper} />
        <Route path='/builder' component={BuilderPageWrapper} />
        <Route path='/crafted/pages/profile' component={ProfilePage} />
        <Route path='/crafted/pages/wizards' component={WizardsPage} />
        <Route path='/crafted/widgets' component={WidgetsPage} />
        <Route path='/crafted/account' component={AccountPage} />
        <Route path='/apps/chat' component={ChatPage} />
        <Route path='/menu-test' component={MenuTestPage} />
        <Route path='/master/country' component={CountryMasterPage} />
        <Route path='/master/taluka' component={TalukaMasterPage} />
        <Route path='/master/nationality' component={NationalityMasterPage} />
        <Route path='/master/eduDepartment' component={EducationDepartmentPage} />
        <Route path='/master/eduCategory' component={EducationCategoryPage} />
        <Route path='/master/documenttype' component={DocumentTypePage} />
        <Route path='/master/kycdocument' component={KycDocumentMasterPage} />
        <Route path='/master/bannerimage' component={BannerImageMasterPage} />
        <Route path='/organization/employee' component={EmployeeMasterPage} />
        <Route path='/organization/user' component={UserMasterPage} />
        <Route path='/organization/customer' component={CustomerMasterPage} />
        <Route path='/master/department' component={DepartmentMasterPage} />
        <Route path='/master/designation' component={DesignationMasterPage} />
        <Route path='/master/branch' component={BranchMasterPage} />
        <Route path='/master/bank' component={OrganizationBankMasterPage} />
        <Route path='/master/blog' component={BlogMasterPage} />
        <Route path='/master/event' component={EventMasterPage} />
        <Route path='/master/album-media' component={AlbumMediaMasterPage} />
        <Route path='/master/album' component={AlbumMasterPage} />
        <Route path='/master/donation' component={ServiceMasterPage} />
        <Route path='/master/member-type' component={MemberTypeMasterPage} />
        {/* ==================== Locations ============== */}
        <Route path='/locations/state' component={StateMasterPage} />
        <Route path='/locations/country' component={CountryMasterPage} />
        <Route path='/locations/city' component={CityMasterPageMasterPage} />
        <Route path='/locations/areapincode' component={AreaPinCodeMasterPage} />
        {/* //=============== Configuration ============= */}
        <Route path='/configuration' component={ConfigurationMasterPage} />
        <Route path='/product-manage/item-category' component={ItemCategoryMaterPage} />
        <Route path='/product-manage/items' component={ItemMasterPage} />
        {/* //============ Ram Nam Book Bank ============ */}
        <Route path='/ram-nam-bank/active-member' component={ActiveMemberMasterPage} />
        <Route path='/ram-nam-bank/not-verified-member' component={NotVerifiedMemberMasterPage} />
        <Route path='/ram-nam-bank/inward-outward-book' component={InwardOutwardMasterPage} />
        <Route path='/orders' component={OrderMasterMasterPage} />
        <Route path='/address-report' component={AddressReportMasterPage} />
        <Route path='/ram-nam-bank/member-report' component={MemberReportMasterPage} />
        <Route path='/forgot-password' component={RequestForgotPasswordMasterPage} />

        <Redirect from='/' to='/dashboard' />
        <Redirect exact from='/' to='/dashboard' />
        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  )
}
